import React, {useState} from 'react'
import {updateSupplier, getSupplierById} from "../../services/serviceSupplier";
import {Button, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const SupplierEdit = ({supplier, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleEditClick = () => {
        getSupplierById(supplier.id)
            .then(({data}) => {
                form.setFieldsValue({
                    supplierName: data.name,
                    supplierCode: data.code,
                    supplierDescription: data.description,
                    supplierPhone: data.phone,
                    supplierEmail: data.email,
                    supplierAddress: data.address,
                })
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.supplierName,
            code: list.supplierCode,
            description: list.supplierDescription,
            phone: list.supplierPhone,
            email: list.supplierEmail,
            address: list.supplierAddress,
            id: supplier.id
        }
        updateSupplier(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Button  type={'link'} onClick={()=>handleEditClick()}> Güncelle </Button>

            <Modal
                open={editModal}
                onCancel={()=>setEditModal(!editModal)}
                title={`Güncelle`}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=>form.submit()}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Tedarikçi Adı'}
                        name={'supplierName'}
                        rules={[
                            {required:true, message: 'Tedarikçi Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Tedarikçi Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input   />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Kodu'}
                        name={'supplierCode'}
                        rules={[
                            {required: true, message: 'Tedarikçi Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Tedarikçi Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 50, message: 'Tedarikçi Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Açıklaması'}
                        name={'supplierDescription'}
                        rules={[
                            {min:1, max:1000, message: 'Açıklama Alanı En Az 1 En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Telefonu'}
                        name={'supplierPhone'}
                        rules={[
                            {max: 20, message: 'Telefon Alanı En Fazla 20 Karakter Olmalı'},
                            {pattern: /^\d*$/, message: 'Tedarikçi Telefonu Sadece Rakam İçermelidir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Email'}
                        name={'supplierEmail'}
                        rules={[
                            {type: 'email', message: 'Doğru Bir E-mail Formatı Giriniz (örnek@örnek.com)'},
                            {max: 100, message: 'E-mail alanı En Fazla 100 Karakter Olmalı'}
                        ]}
                    >
                        <Input  />
                    </Form.Item>
                    <Form.Item
                        label={'Tedarikçi Adres'}
                        name={'supplierAddress'}
                        rules={[
                            {max: 1000, message: 'Adres Alanı En Fazla 1000 Karakter Olmalı'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default SupplierEdit